module.exports = __webpack_public_path__ + "img/广州邮政局.80aecc77.png";